import { useEffect, useState, useContext } from "react"
import {
	Box,
	Heading,
	Text,
	Button,
	Stack,
	useToast,
	useDisclosure,
	Input,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalCloseButton,
	ModalBody,
	ModalFooter,
} from "@chakra-ui/react";
import AuthContext from '../../contexts/AuthContext';
import axios from 'axios'
import { useCompany } from "../../contexts/CompanyContext";

const Home = () => {
	const toast = useToast();
	const {getToken} = useContext(AuthContext);
	const { selectedCompany, setSelectedCompany } = useCompany();

	const {
		isOpen: isCreateOpen,
		onOpen: onCreateOpen,
		onClose: onCreateClose,
	} = useDisclosure();
	const {
		isOpen: isJoinOpen,
		onOpen: onJoinOpen,
		onClose: onJoinClose,
	} = useDisclosure();

	const [companyName, setCompanyName] = useState("");
	const [joinCompanyId, setJoinCompanyId] = useState("");

	const handleCreateCompany = () => {
		axios.post('/api/companies', { 'name': companyName }, {
			headers: {
				Authorization: `Bearer ${getToken()}`,
			},
		}).then(response => {
			if (response.status === 201) {
				console.log("Azienda creata con successo");

				toast({
					title: "Azienda creata con successo",
					description: `Created "${companyName}" successfully.`,
					status: "success",
					duration: 3000,
					isClosable: true,
				});

				onCreateClose();

				// TODO: add a small delay to allow the toast to be displayed before redirecting
				
				setSelectedCompany(response.data['company']);
				window.location.href = `/dashboard`;

			} else {
				console.error("Errore nella creazione dell'azienda: " + response.data);

				toast({
					title: "Errore nella creazione dell'Azienda",
					description: response.data,
					status: "error",
					duration: 3000,
					isClosable: true,
				});
			}
		}).catch((error) => {
			console.error("Errore nella creazione dell'azienda: ", error);

			toast({
				title: "Errore nella creazione dell'Azienda",
				description: error.message || "An unexpected error occurred.",
				status: "error",
				duration: 3000,
				isClosable: true,
			});
		});



	};

	const handleJoinCompany = () => {
		// TODO: call API to request join
		toast({
			title: "Request Sent",
			description: `Request to join company ID "${joinCompanyId}" has been sent.`,
			status: "info",
			duration: 3000,
			isClosable: true,
		});
		onJoinClose();
	};

	return (
		<Box p={8}>
			<Heading mb={4}>Welcome to EdilPro</Heading>
			<Text fontSize="lg" mb={6}>
				You're not part of a company yet. Get started by creating a new one or requesting to join an existing one.
			</Text>

			<Stack direction={["column", "row"]} spacing={4}>
				<Button colorScheme="teal" onClick={onCreateOpen}>
					Create New Company
				</Button>
				<Button colorScheme="blue" onClick={onJoinOpen}>
					Join Existing Company
				</Button>
			</Stack>

			{/* Create Company Modal */}
			<Modal isOpen={isCreateOpen} onClose={onCreateClose}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Create Company</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Input
							placeholder="Company Name"
							value={companyName}
							onChange={(e) => setCompanyName(e.target.value)}
						/>
					</ModalBody>
					<ModalFooter>
						<Button colorScheme="teal" onClick={handleCreateCompany}>
							Create
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>

			{/* Join Company Modal */}
			<Modal isOpen={isJoinOpen} onClose={onJoinClose}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Join Company</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Input
							placeholder="Company ID"
							value={joinCompanyId}
							onChange={(e) => setJoinCompanyId(e.target.value)}
						/>
					</ModalBody>
					<ModalFooter>
						<Button colorScheme="blue" onClick={handleJoinCompany}>
							Request to Join
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</Box>
	);
};

export default Home;